const globalRegular = '<ws-global[^>]+src=[\'|"][^\'|"]+[\'|"][^>]*>';

export default {
  WS_GLOBAL: new RegExp(globalRegular),
  WS_GLOBAL_ALL: new RegExp(globalRegular, 'g'),
  WS_GLOBAL_SOURCE: /\ssrc=(?:'|")([^"']+)/,
  CLEAR_TAGS: new RegExp(/<\/?[^>]+>/g),
  WS_GLOBAL_ID_FROM_SOURCE: /([\w-]+)(?:\/\w{2}(?:-\w{2})?)?\/[\w-]+\.html/i,
};
